module.exports = __webpack_public_path__ + "img/logo-xzrlzy.91c6858b.png";